module.exports = __webpack_public_path__ + "static/media/3DPPA10.635d8e1e.jpg";